import React from 'react';
import { Link, Text } from 'library/ui';

import ThanksForFeedback from '../components/ThanksForFeedback';
import { MainContainer, TextContainer } from '../components/Containers';

export default function DoNotAddPreferredWorkers() {
    return (
        <MainContainer>
            <ThanksForFeedback />
            <TextContainer>
                <Text align="center">No updates have been made to your preferred workers list.</Text>
            </TextContainer>
            <Link to="/home" weight="semibold">
                Back home
            </Link>
        </MainContainer>
    );
}
